import { Controller } from "@hotwired/stimulus"
import { Collapse } from "bootstrap"

export default class extends Controller {
  static targets = ["handler", "content"]

  connect() {
    this.collapse = new Collapse(this.contentTarget, { toggle: false })
  }

  disconnect() {
    this.collapse.dispose()
  }

  toggle() {
    this.handlerTarget.classList.toggle("shown", !this.contentTarget.classList.contains("show"))
    this.collapse.toggle()
  }

  show() {
    this.collapse.show()
    this.handlerTarget.classList.add("shown")
  }

  hide() {
    this.collapse.hide()
    this.handlerTarget.classList.remove("shown")
  }
}
